import { Button, Image, Text, Toaster } from '@msc-b2c/shared-components';
import styles from './confirmation.module.scss';
import { ConfirmationProps } from '@msc-b2c/interfaces/types';

export function Confirmation({
  checkIconImgReference,
  checkIconImgAltText,
  confirmationTitle,
  confirmationDescription,
  myMscLinkLabel,
  myMscLink,
  checkIconImgDMURL,
  warningsArray,
}: Readonly<ConfirmationProps>) {
  return (
    <div className={styles['confirmationContainer']}>
      <Image
        src={checkIconImgDMURL || checkIconImgReference}
        alt={checkIconImgAltText}
        loading={'eager'}
      />
      <div className={styles['confirmationContainer__texts']}>
        <Text
          text={confirmationTitle}
          styleOption="header-l"
        />
        <Text
          text={confirmationDescription}
          styleOption="cmp-text__big"
        />
        {warningsArray?.map((warning, index) => (
          <Toaster
            key={`warning-${index}-${warning.text}`}
            isAutoClosing={false}
            ToasterTitle={warning.text}
            ToasterMessage={warning.description}
            type={'warning'}
            closeButton={false}
            displayIcon={true}
            position="relative"
            displayActions={false}
          />
        ))}
        <Button
          text={myMscLinkLabel}
          buttonLink={myMscLink}
        />
      </div>
    </div>
  );
}

export default Confirmation;
